import HourlySlotsContainer from "../../container/admin/hourly-slots";

const HourlySlotsView = () => {
    return <HourlySlotsContainer />;
};

export default HourlySlotsView;
